import React from "react";
import { Shield, Eye, Lock, Database, Mail } from "lucide-react";

export default function PrivacyPolicy() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-950 text-white relative overflow-hidden">
      {/* Animated Gradient Orbs */}
      <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-600/30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-indigo-600/30 rounded-full blur-3xl animate-ping"></div>

      <div className="relative max-w-4xl mx-auto p-8 space-y-8 z-10">

        {/* Header */}
        <div className="text-center">
          <h1 className="text-4xl font-extrabold flex items-center justify-center gap-3 mb-4">
            <Shield className="w-10 h-10 text-blue-500 animate-bounce" />
            Privacy Policy
          </h1>
          <p className="text-gray-400 text-lg">Last updated: October 6, 2025</p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">

          {/* Information We Collect */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-blue-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Database className="w-6 h-6 text-blue-400" /> Information We Collect
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Personal Information:</strong> Name, email address, and profile picture when you create an account.</p>
              <p><strong>Usage Data:</strong> Information about how you interact with our music streaming service.</p>
              <p><strong>Device Information:</strong> IP address, browser type, and operating system for technical support.</p>
            </div>
          </div>

          {/* How We Use Information */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-indigo-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Eye className="w-6 h-6 text-blue-400" /> How We Use Your Information
            </h2>
            <div className="space-y-3 text-gray-300">
              <p>• Provide and maintain our music streaming service</p>
              <p>• Personalize your music recommendations and experience</p>
              <p>• Process payments and manage subscriptions</p>
              <p>• Send you important updates and promotional content</p>
              <p>• Improve our platform and develop new features</p>
            </div>
          </div>

          {/* Information Sharing */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-blue-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Lock className="w-6 h-6 text-blue-400" /> Information Sharing & Disclosure
            </h2>
            <div className="space-y-3 text-gray-300">
              <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              <p>• With your explicit consent</p>
              <p>• With service providers who assist in operating our platform</p>
              <p>• When required by law or to protect our rights</p>
              <p>• In connection with a business transfer or acquisition</p>
            </div>
          </div>

          {/* Data Security */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-indigo-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Shield className="w-6 h-6 text-blue-400" /> Data Security
            </h2>
            <div className="space-y-3 text-gray-300">
              <p>We implement industry-standard security measures to protect your personal information:</p>
              <p>• Encryption of data in transit and at rest</p>
              <p>• Regular security audits and updates</p>
              <p>• Access controls and authentication requirements</p>
              <p>• Secure data centers with restricted access</p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-blue-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Mail className="w-6 h-6 text-blue-400" /> Contact Us
            </h2>
            <div className="space-y-3 text-gray-300">
              <p>If you have any questions about this Privacy Policy, please contact us:</p>
              <p><strong>Email:</strong> samasong.music@gmail.com</p>
              <p><strong>Address:</strong> old market, Tawang, Arunachal Pradesh, 790104</p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}